<template>
    <div class="forbidden-view">
        <div class="code">
            401
        </div>
        <div>
            <div></div>
            <div class="flex flex-column align-items-center justify-content-center gap-6">
                <h2 class="text-6xl text-center">{{ $t('message.errorPage.accessDenied') }}</h2>
                <span class="text-2xl text-center">{{ $t('message.errorPage.contact') }}</span>
                <router-link class="redirect-button" custom v-slot="{ navigate }"
                             :to="{path: '/'}">
                    <CustomButton @click="navigate" @keypress.enter="navigate"
                                  :label="$t('message.errorPage.back')" />
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import CustomButton from "@/components/form/CustomButton.vue";

    export default {
        name: "ForbiddenView",
        components: {CustomButton},
    };
</script>

<style lang="scss" scoped>
    @import "../assets/theme/mytheme/variables";

    .forbidden-view {
        min-height: 100vh;
        background-color: var(--primary-color);
        padding: 4rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        .code {
            font-size: 10rem;
        }
    }
</style>